import { Question } from './../../../autentication/models/question';

export class ChangeSecurityQuestions {

	questions: Question[];
	success: boolean;
	message: string;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-security-questions/model/change-security-questions.ts